import { Breadcrumbs } from "components/breadcrumbs";
import { useOne } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import { IExchangeRateItem } from "interfaces";
import { ExchangeRateCard, ExchangeRateTable, Filter } from "./components";
import { isEmpty } from "lodash";
import { useMemo, useState } from "react";
import moment from "moment";

export const ExchangeRateList: React.FC = () => {
  const [filters, setFilters] = useState({
    created_at: moment().format("YYYY-MM-DD")
  });

  const { data, isLoading } = useOne<IExchangeRateItem>({
    resource: "currency/detail",
    id: "",
    meta: {
      resource: "data",
      filters: [{
        field: "created_at", operator: "eq", value: filters.created_at
      }]
    },
  });

  if (isLoading) {
    return <FullScreenLoading />
  }

  const exchangeRateData = data?.data;

  return (
    <div className="wrapper">
      <Breadcrumbs />
      <div className="box-container">
        <Filter currentFilterValues={filters} setFilters={setFilters} exchangeRateData={exchangeRateData} />
      </div>
      <div className="box-container">
        {(!isEmpty(exchangeRateData) && !isLoading) ? (
          <>
            <div className="sm:hidden">
              <ExchangeRateCard data={exchangeRateData} />
            </div>
            <div className="hidden sm:block">
              <ExchangeRateTable data={exchangeRateData} />
            </div>
          </>
        ) : (
          <div className="text-center">
            No data
          </div>
        )}
      </div>
      {isLoading ? <FullScreenLoading /> : <></>}
    </div>
  )
};